// @flow
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import styles from './PostDetails.styles.js';
import Category from 'app/components/Category';
import Jalali from 'app/components/Jalali';
import Icon from 'app/components/Icon';
import AuthorAvatar from 'app/components/AuthorAvatar';
import {scrollTo} from 'utils/Helper';

class PostDetails extends React.Component<Props> {

  isAdmin = false;

  scrollToComments = e => {
    e.preventDefault();
    scrollTo('#post-comments-wrapper');
  }

  onShortlinkClick = (e) => {
    const text = e.target.value;
    try {
        var Copied = text.createTextRange();
        Copied.execCommand("Copy");
    }
    catch (err) {
        window.prompt("Copy to clipboard: Ctrl+C/Cmd+C, Enter", text);
    }
  }

  render() {
    const classes = this.props.classes;
    const {
      postId,
      timestamp,
      category,
      pageShortlink,
      commentCount,
      thumbnail,
      title,
      excerpt,
    } = this.props.data;
    const author = this.props.data.author || {};

    return (
      <div className={classes.details}>
        <div className={classes.detailsRow}>
          <Category id={category.id} name={category.name} slug={category.slug} />
        </div>
        <div className={classes.detailsRow}>
          <Jalali timestamp={timestamp} />
          <Icon name="calendar" className={classes.icons} />
        </div>
        <div className={classes.detailsRow}>
          <Icon name="link" />
          <input
            readOnly
            onClick={this.onShortlinkClick}
            className={classes.shortlink}
            defaultValue={pageShortlink}
          />
        </div>

        {this.props.isAdmin &&
          <div className="edit">
            <Icon name="chat_bubble" />
            <a href={`https://caffecinema.com/admin/posts/edit/${postId}`}>
              ویرایش
            </a>
          </div>
        }

        <div className="comment-count">
          <Icon name="chat_bubble" />
          <Link
            to="#"
            onClick={this.scrollToComments}
          >
            دیدگاه ({commentCount})
          </Link>
        </div>
        <div className="widget-post-share-buttons">
          <span className={classes.sharesLabel}>اشتراک گذاری:</span>
          <div className={classes.shareIconsWrapper}>
            <a
              rel="noopener noreferrer"
              href={`tg://msg_url?url=${pageShortlink}&text=${title}`}>
              <Icon
                className={classes.shareIcon}
                name="telegram"
                color="#0088cc"
              />
            </a>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.facebook.com/sharer/sharer.php?u=${pageShortlink}&picture=https://caffecinema.com${thumbnail}&title=${title}&description=${excerpt}`}
            >
              <Icon
                className={classes.shareIcon}
                name="facebook"
                color="#3b5998"
              />
            </a>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://twitter.com/intent/tweet?url=${pageShortlink}&text=${title}`}
            >
              <Icon
                className={classes.shareIcon}
                name="twitter"
                color="#55acee"
              />
            </a>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`mailto:?subject=${pageShortlink}&body=${pageShortlink}%0D%0A${excerpt}`}
            >
              <Icon
                className={classes.shareIcon}
                name="markunread"
                color="#410093"
              />
            </a>
          </div>
        </div>

        {author.name &&
          <AuthorAvatar
            name={author.name}
            slug={author.uname}
            image={author.image}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  navigation: state.navigation,
  categoryId: state.navigation.category.id
});

const Component = connect(mapStateToProps)(withStyles(styles)(PostDetails));
export {Component as PostDetails};
export default Component;